// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GFND","colBig":"styles_colBig__2kP4x","colSmall":"styles_colSmall__3xFs4","shopifyNameWrapper":"styles_shopifyNameWrapper__1Vk3O"};